import { IReduxStateData } from "../interfaces/redux";

export default function GetActiveDealAdvertisement(globalState: IReduxStateData, position: number, page: number) {
    const dealAdvertisement = globalState?.activeDealAdvertisement || [];
    if (dealAdvertisement.length) {
        const itemList = dealAdvertisement.filter((item: any) => {
            return (position ? item.position === position && item.page === page : item.page === page)
        });
        if (itemList.length) {
            if (itemList.length === 1) {
                return itemList[0];
            } else {
                return itemList;   
            }
        }
        return;
    }
    return;
}